export const shareOfVoicePage = {
  id: 'sharedofvoice',
  name: _TL_('Share of Voice'),
  route: 'hotelcenter/sharedofvoice',
  checkPermission: permissions => permissions.dynamic.HotelAds && !permissions.dynamic.HotelCenterV2,
};
